module.exports = "/build/web/svg/social/small/twitter.dfb12e9dd0bb380bb9248a63f18e10d7.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/twitter.svg
// module id = 195
// module chunks = 24